import React from 'react';

const CharacterLimitInput = ({
  value = '',
  onChange,
  maxLength = 50,
  showCounter = true,
  counterPosition = 'end', // 'end' or 'below'
  className = '',
  placeholder = '',
  name = '',
  id = '',
  error = '', // External validation error
  ...props
}) => {
  const currentLength = value?.length || 0;
  const isExceeded = currentLength > maxLength;
  const hasError = isExceeded || error;

  const handleChange = (e) => {
    onChange(e); // Allow typing beyond limit
  };

  return (
    <div className="character-limit-container" style={{ position: 'relative' }}>
      <input
        type="text"
        className={`form-control common-input-all ${className} ${
          hasError ? 'is-invalid' : ''
        }`}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        name={name}
        id={id}
        {...props}
        style={{
          ...(hasError
            ? {
                border: '1px solid red !important',
                // boxShadow: '0 0 0 1px red !important',
                background: 'white'
              }
            : {border: '1px solid #6C757D'}),
        }}
      />

      {/* Character Counter */}
      {showCounter && (
        <div
          className={`character-counter ${
            counterPosition === 'below' ? 'counter-below' : 'counter-end'
          }`}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: counterPosition === 'below' ? '4px' : '0',
            fontSize: '12px',
            color: isExceeded ? '#DC3545' : '#6c757d',
            position: 'relative',
            minHeight: '20px'
          }}
        >
          {counterPosition === 'below' && (
            <span>{currentLength}/{maxLength}</span>
          )}
          {counterPosition === 'end' && (
            <span style={{ marginLeft: 'auto' }}>
              {currentLength}/{maxLength}
            </span>
          )}

          {/* Error messages container */}
          <div style={{
            position: 'absolute',
            left: '0',
            bottom: '0',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '2px'
          }}>
            {/* Max Characters error - shown first */}
            {isExceeded && (
              <span
                style={{
                  fontSize: '12px',
                  color: "#DC3545",
                  fontFamily: "Montserrat",
                  fontStyle: 'normal',
                  fontWeight: '400px',
                  lineHeight: 'normal',
                }}
              >
                Max Characters
              </span>
            )}
            
            {/* External error - shown below max characters error if both exist */}
            {error && isExceeded && (
              <span
                style={{
                  fontSize: '12px',
                  color: "#DC3545",
                  fontFamily: "Montserrat",
                  fontStyle: 'normal',
                  fontWeight: '400px',
                  lineHeight: 'normal',
                }}
              >
                {error}
              </span>
            )}
          </div>

          {/* Single error case - when only external error exists */}
          {error && !isExceeded && (
            <span
              style={{
                position: 'absolute',
                left: '0',
                bottom: '0',
                fontSize: '12px',
                  color: "#DC3545",
                  fontFamily: "Montserrat",
                  fontStyle: 'normal',
                  fontWeight: '400px',
                  lineHeight: 'normal',
              }}
            >
              {error}
            </span>
          )}
        </div>
      )}

      {/* === CSS to REMOVE the '!' icon === */}
      <style jsx>{`
        .form-control.is-invalid {
          background-image: none !important; /* Removes the '!' icon */
          padding-right: 0.75rem; /* Optional: adjust padding if needed */
        }
        
        /* Ensure red border is applied */
        .form-control.common-input-all.is-invalid {
          border-color: #DC3545 !important;
          // box-shadow: 0 0 0 1px red !important;
        }
      `}</style>
    </div>
  );
};

export default CharacterLimitInput;